export default "__VITE_ASSET__DacxCqdO__"